import { useCallback } from 'react';
import { useToast as useToastOriginal, UseToastOptions } from '@chakra-ui/react';

interface ToastProps extends UseToastOptions {
  title?: string;
  description?: string;
  status?: 'info' | 'warning' | 'success' | 'error';
  duration?: number | null;
  isClosable?: boolean;
  id?: string;
}

const useToast = () => {
  const toast = useToastOriginal();

  const createToast = useCallback(
    ({ title, description, status, duration, isClosable, id }: ToastProps) => {
      toast({
        title,
        description,
        status,
        duration,
        isClosable,
        id,
      });
    },
    [toast],
  );

  return { createToast };
};

export default useToast;
